import { useEffect } from "react";
import { GroupUsersCard } from "./card";
import { GroupUsersNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { GroupUsersTable } from "./table";

export default function GroupUsers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Groupes d'utilisateurs");
  }, []);

  return (
    <Routes>
      <Route index element={<GroupUsersTable />} />
      <Route path="/new" element={<GroupUsersNew />} />
      <Route path=":id" element={<GroupUsersCard />} />
    </Routes>
  );
}
